<template>
    <LeftAsideSubLayout title="Manufacturers">
        <template #aside>
            <div class="h-full">
                <span class="h-full w-full hidden at1024:block app-scrollbar">
                    <SeclockMultiselect
                        class="mt-4 mx-4 mb-4"
                        :options="manufacturers?.filter((manufacturer) => manufacturer.logo)?.map((manufacturer) => ({'label': manufacturer.name,'value': manufacturer.slug}))"
                        :placeholder="$t('Select A Manufacturer')"
                        :searchable="true"
                        :can-clear="false"
                        :large="true"
                        @change="navigateToShow($event)"
                    />
                    <span class="pl-6 block w-full type-secondary font-medium pb-4 bg-gray-tier-3">
                        {{ $t("Browse by category") }}
                    </span>
                    <SideNav
                        class="w-full"
                        :sections="tagArray"
                        :click-to-scroll="false"
                        :all="true"
                        v-model="selectedTag"
                    />
                </span>
            </div>
        </template>
        <template #default>
            <ManufacturerContent
                class="!p-10 !pl-2 !pt-1 !pr-10"
                :manufacturers="filteredManufacturers"
                :tags="tags['vendor-category']"
                :external-nav="true"
            />
        </template>
    </LeftAsideSubLayout>
</template>

<script setup>
import {ManufacturerContent, SeclockMultiselect, SideNav} from "@/Components";
import {LeftAsideSubLayout} from "@/Layouts";
import {computed, inject, reactive, ref} from "vue";
import {router, usePage} from "@inertiajs/vue3";

const route = inject("route");
const props = defineProps(["manufacturers", "tags"]);
const query = reactive(usePage().props.query ?? {});
const tagArray = ref(props.tags['vendor-category']);

const selectedTag = computed({
    get: () => {
        return tagArray.value?.find((tag) => tag.name === query.tag);
    },
    set: (tag) => {
        query.tag = tag;
        if(tag){
            query.letter = null;
        }
    },
});

const filteredManufacturers = computed(() => {
    let data = props.manufacturers;

    if (selectedTag.value) {
        return data.filter((manufacturer) =>
            manufacturer.tag_ids?.includes(selectedTag.value.id)
        );
    }

    if (query.letter) {
        return data.filter((manufacturer) =>
            manufacturer.name?.startsWith(query.letter.toLowerCase()) || manufacturer.name?.startsWith(query.letter.toUpperCase())
        );
    }

    return data;
});

const navigateToShow = (slug) => {
    router.visit(route('web.catalog.manufacturers.show', slug))
};
</script>
